(ns shared.core.components.number-picker
  (:require [shared.core.components.button :as button]
            [shared.core.components.icon :as icon]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]
            [shared.core.util :as util]))

(defn large-number-picker [{:keys [val-subscribe form-path form-name]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))
        dark?- (re/subscribe [:core/theme-dark?-])]
    (fn [{:keys [style button-style on-left-click on-right-click number-style default-value form-path form-name
                 disabled? extra-on-left-click extra-on-right-click]}]
      (let [val (or (try
                      (when-let [v (if val- @val- default-value)]
                        (util/parse-int v))
                      (catch :default _ nil))
                    1)
            number-border (str "1px solid " (if @dark?-
                                              (style/dark-color :background :base)
                                              (style/color :green :shade-1)))]
        [theme/theme
         :div {:style (merge {:color (style/color :gray :base)
                              :display :flex
                              :align-items :center}
                             style)
               :theme (style/dark-style {:color (style/dark-color :on-background :base)})}
         [button/green-button {:style (merge {:border-radius "3px 0 0 3px"
                                              :padding "0 9px"}
                                             button-style)
                               :disabled? (or disabled? (<= val 1))
                               :on-click (or on-left-click
                                             #(do
                                                (when (and form-path form-name)
                                                  (re/dispatch [:form/change form-path form-name (dec val)]))
                                                (when extra-on-left-click
                                                  (extra-on-left-click %))))
                               :size :large}
          [icon/material-icon {:icon-type :remove
                               :style {:color :inherit}}]]
         [theme/theme
          :div {:style (merge {:background-color (style/color :white :base)
                               :border-top number-border
                               :border-bottom number-border
                               :color :inherit
                               :display :flex
                               :align-items :center
                               :justify-content :center
                               :padding "0 14px"
                               :height (or (:height button-style) 40)
                               :width (+ (* 10 (count (str val))) 30)}
                              number-style)
                :theme (style/dark-style {:background-color (style/dark-color :background :base)})}
          (util/readable-number val)]
         [button/green-button {:style (merge {:border-radius "0 3px 3px 0"
                                              :padding "0 9px"}
                                             button-style)
                               :size :large
                               :disabled? disabled?
                               :on-click (or on-right-click
                                             #(do
                                                (when (and form-path form-name)
                                                  (re/dispatch [:form/change form-path form-name (inc val)]))
                                                (when extra-on-right-click
                                                  (extra-on-right-click %))))}
          [icon/material-icon {:icon-type :add
                               :style {:color :inherit}}]]]))))

(defn number-picker [{:keys [val-subscribe form-path form-name on-container-click]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))]
    (fn [{:keys [style on-left-click on-right-click extra-on-left-click extra-on-right-click number-style default-value
                 form-path form-name disabled? value minimum maximum pause-disabled-click-events? dark-color]
          :or {minimum 1
               dark-color (style/dark-color :on-background :base)}}]
      (let [val (or (try
                      (when-let [v (if val- @val- default-value)]
                        (util/parse-int v))
                      (catch :default _ nil))
                    value
                    minimum)
            left-disabled? (or disabled? (<= val minimum))
            right-disabled? (or disabled? (and maximum (>= val maximum)))]
        [theme/theme
         :div {:style (merge {:color (style/color :gray :base)
                              :display :flex
                              :align-items :center}
                             style)
               :theme (style/dark-style {:color dark-color})
               :on-click on-container-click}
         [icon/material-icon {:icon-type :remove
                              :style (cond-> {:color :inherit
                                              :font-size 17
                                              :cursor :pointer
                                              :user-select :none}
                                             left-disabled? (assoc :cursor :not-allowed
                                                                   :opacity 0.5))
                              :on-click (if left-disabled?
                                          (when pause-disabled-click-events? util/stop-event)
                                          (or on-left-click
                                              #(do
                                                 (when (and form-path form-name)
                                                   (re/dispatch [:form/change form-path form-name (dec val)]))
                                                 (when extra-on-left-click
                                                   (extra-on-left-click %)))))}]
         [:div {:style (merge {:color :inherit
                               :font-size 14
                               :display :flex
                               :align-items :center
                               :justify-content :center
                               :padding "0 6px"
                               :user-select :none
                               :width (+ (* 8 (count (str val))) 12)}
                              number-style)}
          (util/readable-number val)]
         [icon/material-icon {:icon-type :add
                              :style (cond-> {:color :inherit
                                              :font-size 17
                                              :cursor :pointer
                                              :user-select :none}
                                             right-disabled? (assoc :cursor :not-allowed
                                                                    :opacity 0.5))
                              :on-click (if right-disabled?
                                          (when pause-disabled-click-events? util/stop-event)
                                          (or on-right-click
                                              #(do
                                                 (when (and form-path form-name)
                                                   (re/dispatch [:form/change form-path form-name (inc val)]))
                                                 (when extra-on-right-click
                                                   (extra-on-right-click %)))))}]]))))

(defn circle-with-icon [{:keys [container-style circle-style icon-type icon-weight icon-style on-click]
                         :or {icon-weight :bold}}]
  [:div {:style (merge {:padding 3}
                       container-style)
         :on-click on-click}
   [:div {:style (merge {:border (str "1px solid " (style/color :gray :shade-16))
                         :border-radius "50%"
                         :position :relative
                         :height 20
                         :width 20}
                        circle-style)}
    [icon/phosphor-icon {:icon-type icon-type
                         :weight icon-weight
                         :style (merge {:color (style/color :gray :shade-16)
                                        :font-size 13
                                        :position :absolute
                                        :top "50%"
                                        :left "50%"
                                        :transform "translate(-50%, -50%)"}
                                       icon-style)}]]])

(defn mini-number-picker [{:keys [val-subscribe form-path form-name on-container-click]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))]
    (fn [{:keys [style on-left-click on-right-click extra-on-left-click extra-on-right-click number-style default-value
                 form-path form-name disabled? value minimum maximum pause-disabled-click-events? dark-color icon-style]
          :or {minimum 0
               dark-color (style/dark-color :on-background :base)}}]
      (let [val (or (try
                      (when-let [v (if val- @val- default-value)]
                        (util/parse-int v))
                      (catch :default _ nil))
                    value)
            val? (some-> val (pos?))
            left-disabled? (or disabled? (not val?))
            right-disabled? (or disabled? (and maximum (>= val maximum)))]
        [theme/theme
         :div {:style (merge {:color (style/color :black :base)
                              :display :flex
                              :align-items :center}
                             style)
               :theme (style/dark-style {:color dark-color})
               :on-click on-container-click}
         (when val?
           (let [trash-can? (= val 1)]
             [circle-with-icon {:container-style (cond-> {:cursor :pointer
                                                          :user-select :none}
                                                         left-disabled? (assoc :cursor :not-allowed
                                                                               :opacity 0.5))
                                :icon-type (if trash-can?
                                             :trash-simple
                                             :minus)
                                :icon-style (merge (when trash-can? {:top "53%"})
                                                   icon-style)
                                :on-click (if left-disabled?
                                            (when pause-disabled-click-events? util/stop-event)
                                            (or on-left-click
                                                #(do
                                                   (when (and form-path form-name)
                                                     (re/dispatch [:form/change form-path form-name (dec val)]))
                                                   (when extra-on-left-click
                                                     (extra-on-left-click %)))))}]))
         (when val?
           [:div {:style (merge {:color :inherit
                                 :font-size 14
                                 :font-weight style/font-medium-weight
                                 :line-height 1.2
                                 :display :flex
                                 :align-items :center
                                 :justify-content :center
                                 :padding "0 10px"
                                 :user-select :none
                                 :width (+ (* 7 (count (str val))) 14)}
                                number-style)}
            (util/readable-number val)])
         [circle-with-icon {:container-style (cond-> {:cursor :pointer
                                                      :user-select :none}
                                                     right-disabled? (assoc :cursor :not-allowed
                                                                            :opacity 0.5))
                            :icon-type :plus
                            :icon-style icon-style
                            :on-click (if right-disabled?
                                        (when pause-disabled-click-events? util/stop-event)
                                        (or on-right-click
                                            #(do
                                               (when (and form-path form-name)
                                                 (re/dispatch [:form/change form-path form-name (inc val)]))
                                               (when extra-on-right-click
                                                 (extra-on-right-click %)))))}]]))))

(defn pill-number-picker [{:keys [val-subscribe form-path form-name on-container-click]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))]
    (fn [{:keys [style on-left-click on-right-click extra-on-left-click extra-on-right-click number-style default-value
                 form-path form-name disabled? value minimum maximum pause-disabled-click-events? dark-color]
          :or {minimum 1
               dark-color (style/dark-color :on-background :base)}}]
      (let [val (or (try
                      (when-let [v (if val- @val- default-value)]
                        (util/parse-int v))
                      (catch :default _ nil))
                    value
                    minimum)
            left-disabled? (or disabled? (<= val minimum))
            right-disabled? (or disabled? (and maximum (>= val maximum)))]
        [:div {:style (merge {:background-color (style/color :white :base)
                              :box-shadow "0px 0px 6px 0px rgba(0, 0, 0, 0.15)"
                              :color (style/color :gray :shade-16)
                              :border-radius 19
                              :display :flex
                              :align-items :center
                              :padding "4px 12px"}
                             style)
               :on-click on-container-click}
         [icon/phosphor-icon {:icon-type :minus
                              :style (cond-> {:color :inherit
                                              :font-size 17
                                              :cursor :pointer
                                              :user-select :none
                                              :padding 2}
                                             left-disabled? (assoc :cursor :not-allowed
                                                                   :opacity 0.5))
                              :on-click (if left-disabled?
                                          (when pause-disabled-click-events? util/stop-event)
                                          (or on-left-click
                                              #(do
                                                 (when (and form-path form-name)
                                                   (re/dispatch [:form/change form-path form-name (dec val)]))
                                                 (when extra-on-left-click
                                                   (extra-on-left-click %)))))}]
         [:div {:style (merge {:color (style/color :black :base)
                               :font-size 20
                               :font-weight style/font-regular-weight
                               :line-height 1.2
                               :display :flex
                               :align-items :center
                               :justify-content :center
                               :user-select :none
                               :width (+ (* 12 (count (str val))) 40)}
                              number-style
                              (when disabled?
                                {:opacity 0.55}))}
          (util/readable-number val)]
         [icon/phosphor-icon {:icon-type :plus
                              :style (cond-> {:color :inherit
                                              :font-size 17
                                              :cursor :pointer
                                              :user-select :none
                                              :padding 2}
                                             right-disabled? (assoc :cursor :not-allowed
                                                                    :opacity 0.5))
                              :on-click (if right-disabled?
                                          (when pause-disabled-click-events? util/stop-event)
                                          (or on-right-click
                                              #(do
                                                 (when (and form-path form-name)
                                                   (re/dispatch [:form/change form-path form-name (inc val)]))
                                                 (when extra-on-right-click
                                                   (extra-on-right-click %)))))}]]))))
